export const environment = {
  production: true,
  serverURL: '/server',
  currentEnvironment: 'prod',
  accessTokenKey: 'ProdIlsPlayerAccessTokenKey',
  refreshTokenKey: 'ProdIlsPlayerRefreshTokenKey',
  playerURL: '/ils-player',
  editorURL: '/ils-editor',
  gateHtmlURL: '/gateway-html',
  profileKey: 'ProdIlsPlayerProfileKey',
  translationServiceURL: 'https://translate-apps.bms.utwente.nl/server',
}
